import { defineComponent as _defineComponent } from 'vue'
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import { Badge } from '@/components/docs-main/reference-pages/badge';
import type { ArticleHeaderProps } from '@/components/docs-main/article-header';


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleHeader',
  props: {
    value: null
  },
  setup(__props: any) {



return { __sfc: true,DocIcon, Badge }
}

})